import './dashboard.css';
import CardDashboard from "../../components/dashboardComponents/cardDashboard/cardDashboard";
import DashboardChart from "../../components/dashboardComponents/dashboardChart/DashboardChart";
import OverallSummary from "../../components/overallSummary/overallSummary";
import FleetComparison from "../../components/dashboardComponents/fleetComparison/fleetComparison";
import DashCompareChart from "../../components/dashboardComponents/dashCompareChart/dashCompareChart";
import RadioButton from "../../shared/radioButton/radioButton";
import CalendarType from "../../shared/calendarType/calendarType";
import DateRangePicker from "../../shared/dateRangePicker/dateRangePicker";
import DriverCards from "../../components/driverCards/driverCards";
import {useState} from "react";

const Dashboard = () => {
    const [driverType, setDriverType] = useState('worst');

    return(
        <div className={'content-section page-fade-in'}>
            <div className=" round-corner-8 padding-tb-20 flex hr-right border-bottom margin-b-30">
                <DateRangePicker selectRange={true} classes={'date width-300 item-height-40'}/>
                <CalendarType/>
            </div>


            <div className="">
                {/*<GoogleMaps/>*/}
            </div>

            {/*..... card dashboard .....*/}
            <div className="margin-b-50"><CardDashboard/></div>

            {/*........ chart .......*/}
            <div className="margin-b-50">
                <div className="sf-medium font-18 margin-b-15">Safety Performance</div>
                <div className="dashboard-chart"><DashboardChart/></div>
            </div>

            {/*........ drivers cards .....*/}
            <div className="margin-b-50">
                <div className="sf-medium flex hr-space-between section-title margin-b-20">
                    <div className="flex">
                        <div className={`cursor-pointer transition-300 ${driverType !== 'worst' ? 'light-color' : ''}`}
                             onClick={e => setDriverType('worst')}>Worst Drivers</div>
                        <div className={`cursor-pointer transition-300 ${driverType !== 'best' ? 'light-color' : ''}`}
                             onClick={e => setDriverType('best')}>Best Drivers</div>
                    </div>
                    <div className="highlight-color">Show All</div>
                </div>
                <div className=""><DriverCards driverType={driverType}/></div>
            </div>


            {/*..... overall summary .....*/}
            <div className="margin-b-50 border-bottom padding-b-40"><OverallSummary/></div>

            {/*..... comparison sec ......*/}
            <div className="comparison-chart-section flex hr-space-between align-top">
                <div className="comparison-sec">
                    <div className="sf-medium font-18 margin-b-30">Fleet Comparison</div>
                    <FleetComparison/>
                </div>
                <div className="compare-chart-sec">
                   <div className="flex hr-space-between margin-b-30">
                       <div className="sf-medium font-18">
                           Alert Distribution <span className="grey-color sf-light">(comparison to last month)</span>
                       </div>
                       <div className="sf-medium flex gap-50">
                           <label className="flex gap-10 width-content">
                               <RadioButton defaultChecked={true} name={'chart'}/>
                               <div className="">Overall</div>
                           </label>
                           <label className="flex gap-10 width-content">
                               <RadioButton name={'chart'}/>
                               <div className="">Per Driver</div>
                           </label>
                       </div>
                   </div>
                    <div className="compare-chart"><DashCompareChart/></div>
                </div>
            </div>

        </div>
    )
}

export default Dashboard;
